import { registerPlugin } from '@capacitor/core';
const RFID = registerPlugin('RFID', {
    web: () => import('./web').then(m => new m.RFIDWeb()),
});
export * from './definitions';
export { RFID };
//# sourceMappingURL=index.js.map